import { useTranslation } from 'react-i18next';
import {
  StyledCheckIcon,
  StyledCircularProgress,
  StyledContainer,
  StyledErrorMessage,
  StyledErrorRounded,
  StyledStatusMessage,
  StyledSuccessMessage,
} from './styled';

interface PropsType {
  isLoading: boolean;
  isSuccess: boolean;
  error: { message: string };
}
const MessagesContainer = ({ isLoading, isSuccess, error }: PropsType) => {
  const { t } = useTranslation();

  return (
    <>
      {error && (
        <StyledContainer>
          <StyledErrorRounded />
          <StyledErrorMessage>{error.message}</StyledErrorMessage>
        </StyledContainer>
      )}
      {isLoading && (
        <StyledContainer>
          <StyledCircularProgress size={20} />
          <StyledStatusMessage>
            {t(
              'distribution:uploadAudioModal:validation:message:uploadingFile'
            )}
          </StyledStatusMessage>
        </StyledContainer>
      )}
      {isSuccess && (
        <StyledContainer>
          <StyledCheckIcon />
          <StyledSuccessMessage>
            {t(
              'distribution:uploadAudioModal:validation:message:uploadComplete'
            )}
          </StyledSuccessMessage>
        </StyledContainer>
      )}
    </>
  );
};

export default MessagesContainer;
